export default  {
  data() {
    return {
      dietaryPreferences: [
        {
          key: "No dietary preference",
          value: "message.dietPreferenceNone"
        },
        {
          key: "Pescetarian",
          value: "message.dietPreferencePescetarian"
        },
        {
          key: "Vegetarian",
          value: "message.dietPreferenceVegetarian"
        },
        {
          key: "Vegan",
          value: "message.dietPreferenceVegan"
        }
      ]
    }
  },
  methods: {
    localizeDietPreference(key) {


      let self = this;
      let localizedDietPref = self.dietaryPreferences.filter(function (item) {
        return item.key === key;
      });

      if(localizedDietPref.length > 0) {
        return self.$t(localizedDietPref[0].value);
      }

      else {
        return key;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/DietaryPreferences/index.js